import { Box, CircularProgress, Container, Pagination } from "@mui/material";
import { FlexBox } from "components/flex-box";
import LazyImage from "components/LazyImage";
import { H3 } from "components/Typography";
import { useIsMobile } from "hooks";
import { useAppDispatch } from "hooks/use-app-dispatch";
import { useAppSelector } from "hooks/use-app-selector";
import modules from "modules";
import { PromotionalListings } from "modules/promotional/types";
import { useRouter } from "next/router";
import React, { FC, useCallback, useEffect } from "react";

const { selectors: promotionalSelectors, actions: promotionalActions } =
  modules.promotional;

const PromotionalSection: FC = () => {
  const dispatch = useAppDispatch();
  const { push, query } = useRouter();
  const isMobile = useIsMobile();

  const promotionals = useAppSelector(promotionalSelectors.selectListings);
  const meta = useAppSelector(promotionalSelectors.selectMeta);
  const isLoading = useAppSelector(promotionalSelectors.selectLoading);

  const handleNavigate = (i: PromotionalListings) => {
    const url = `/promotional/details/${i.id}?promo=${i.slug}`;
    push(url);
  };

  const getPromotionals = useCallback(
    (page: number) => {
      dispatch(promotionalActions.getPromotionalListingsThunk({ page }));
    },
    [dispatch]
  );

  const onHandlePageChange = useCallback(
    (e: any, val: number) => {
      push(
        {
          pathname: `/promotional`,
          query: {
            page: val,
          },
        },
        undefined,
        { shallow: true }
      );
    },
    [push]
  );

  useEffect(() => {
    const page = +query.page || 1;
    getPromotionals(page);
  }, [getPromotionals, query]);

  if (isLoading) {
    return (
      <Container>
        {isLoading && <CircularProgress color="secondary" size="7em" />}
      </Container>
    );
  }

  return (
    <Box>
      {promotionals[0] && !isLoading ? (
        promotionals.map((i) => (
          <Box key={i.slug} sx={{ mb: isMobile ? "1em" : "2.5em" }}>
            <LazyImage
              onClick={() => handleNavigate(i)}
              src={i.banner_url}
              width={1200}
              height={354}
              layout="responsive"
              objectFit="contain"
              alt={i.slug}
            />
          </Box>
        ))
      ) : (
        <Container>
          <LazyImage
            src={"/assets/images/shock_red_hair.png"}
            width={250}
            height={250}
            loading="eager"
            objectFit="contain"
          />
          <H3 sx={{ marginTop: "1em" }}>No Results</H3>
        </Container>
      )}
      <FlexBox sx={{ my: "2em", justifyContent: "end" }}>
        <Pagination
          count={meta.last_page}
          page={+query?.page || 1}
          onChange={onHandlePageChange}
          size={isMobile ? "small" : "large"}
        />
      </FlexBox>
    </Box>
  );
};

export default PromotionalSection;
